<!-- 额度监控 -->
<template>
  <div class="app-container">
    <el-form :model="searchData" :inline="true" label-width="140px" label-position="right" ref="searchData">
      <el-form-item label="签约公司" prop="signCompanyNameList">
        <el-select v-model="searchData.signCompanyNameList" placeholder="请选择" clearable multiple style="width: 100%">
          <el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="姓名" prop="userName">
        <el-input v-model="searchData.userName" placeholder="请输入" clearable style="width: 100%"></el-input>
      </el-form-item>
      <el-form-item label="身份证" prop="idCard">
        <el-input v-model="searchData.idCard" placeholder="请输入" clearable style="width: 100%"></el-input>
      </el-form-item>
      <el-form-item label="额度监控" prop="limitStatus">
        <el-select v-model="searchData.limitStatus" placeholder="请选择" clearable style="width: 100%">
          <el-option v-for="item in limitStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="btn-group">
      <div class="row-bg">
        <el-button ghost size="medium" @click="batchDialogVisible = true">批量开票</el-button>
        <el-button ghost size="medium" @click="handleInvoiceTemplateDownload" :loading="invoiceTemplateDownloadLoading">批量开票模板下载</el-button>
      </div>
      <div class="row-bg">
        <el-button type="primary" size="medium" @click="handleSearch()">查询</el-button>
        <el-button size="medium" @click="resetForm()">重置</el-button>
      </div>
    </div>

    <el-table ref="checktableData" :data="tableData" v-loading="tableLoading" :reserve-selection="true" center height="60vh">
      <el-table-column label="操作" prop="action" width="140" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" @click="handleInvoice(scope.row)">开票</el-link>
          <el-link style="margin-left: 12px;" type="primary" @click="handleViewDetail(scope.row)">查看明细</el-link>
        </template>
      </el-table-column>
      <el-table-column label="姓名" prop="userName" min-width="100"></el-table-column>
      <el-table-column label="手机号" prop="phone" min-width="120"></el-table-column>
      <el-table-column label="身份证号" prop="idCard" min-width="180"></el-table-column>
      <el-table-column label="签约公司" prop="signCompanyName" min-width="150"></el-table-column>
      <el-table-column label="已用额度" prop="alreadyMoney" min-width="100"></el-table-column>
      <el-table-column label="近12月已用额度" prop="lastMoney" min-width="160"></el-table-column>
      <el-table-column label="额度监控" prop="limitStatus" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.limitStatus === 0 ? '正常' : '超限' }}
        </template>
      </el-table-column>
      <el-table-column label="操作人" prop="operator" min-width="100"></el-table-column>
      <el-table-column label="最近开票时间" prop="operatorDate" min-width="160"></el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="pagination.page"
        :page-size="pagination.rows"
        :page-sizes="[10, 20, 30, 50]"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 开票弹窗 -->
    <InvoiceApplyDialog :dialog-visible.sync="invoiceDialogVisible" :row-data="currentRowData" :invoice-id="currentRowData.invoiceId" @success="handleInvoiceSuccess" />
    <!-- 批量开票弹窗 -->
    <BatchInvoiceDialog :dialog-visible.sync="batchDialogVisible" @success="handleInvoiceSuccess" />
  </div>
</template>
<script>
import { getInvoiceInfoPageList, getCompanyEnum } from '@/api/invoiceManagement'
import InvoiceApplyDialog from './components/InvoiceApplyDialog.vue'
import BatchInvoiceDialog from './components/BatchInvoiceDialog.vue'

export default {
  components: {
    InvoiceApplyDialog,
    BatchInvoiceDialog
  },
  data() {
    return {
      tableData: [],
      tableLoading: false,
      total: 0,
      invoiceTemplateDownloadLoading: false,
      pagination: {
        page: 1,
        rows: 10
      },
      searchData: {
        userName: '',
        idCard: '',
        signCompanyNameList: [],
        limitStatus: ''
      },
      // 开票弹窗相关
      invoiceDialogVisible: false,
      batchDialogVisible: false,
      currentRowData: {},
      // 签约公司枚举
      companyOptions: [],
      // 额度状态枚举
      limitStatusOptions: [
        { label: '正常', value: 0 },
        { label: '超限', value: 1 }
      ]
    }
  },
  created() {
    this.getCompanyEnum()
    this.getList()
  },
  methods: {
    // 获取列表数据
    async getList() {
      this.tableLoading = true
      const params = {
        ...this.searchData,
        ...this.pagination
      }
      try {
        const res = await getInvoiceInfoPageList(params)
        if (res.statusCode === 200) {
          this.tableData = res.data.records || []
          this.total = res.data.total || 0
        } else {
          this.$message.error(res.message || '请求失败')
        }
      } catch (error) {
        console.error('获取签约列表失败', error)
      } finally {
        this.tableLoading = false
      }
    },
    // 查询
    handleSearch() {
      this.pagination.page = 1
      this.getList()
    },
    // 重置
    resetForm() {
      this.$refs.searchData.resetFields()
      this.pagination.page = 1
      this.getList()
    },
    // 页码改变
    handleSizeChange(val) {
      this.pagination.page = 1
      this.pagination.rows = val
      this.getList()
    },
    handleCurrentChange() {
      this.getList()
    },
    // 获取额度状态标签
    getLimitStatusLabel(status) {
      const option = this.limitStatusOptions.find(item => item.value === status)
      return option ? option.label : ''
    },
    // 开票
    handleInvoice(row) {
      this.currentRowData = { ...row }
      this.invoiceDialogVisible = true
    },
    // 开票成功回调
    handleInvoiceSuccess() {
      this.getList()
    },
    // 获取签约公司枚举
    async getCompanyEnum() {
      try {
        const res = await getCompanyEnum()
        if (res.statusCode === 200 && res.data) {
          const companyMap = {
            ZH: '珠海',
            CS: '长沙',
            WH: '芜湖',
            SJZ: '石家庄',
            TJ: '天津',
            ZZ: '郑州'
          }
          this.companyOptions = res.data.map(item => ({
            label: companyMap[item] || item,
            value: item
          }))
        }
      } catch (error) {
        console.error('获取签约公司枚举失败', error)
      }
    },
    handleInvoiceTemplateDownload() {
      this.invoiceTemplateDownloadLoading = true
      setTimeout(() => {
        this.invoiceTemplateDownloadLoading = false
      }, 1200)
      const url = '/autoapp-default-server-recovery/api/file/downLoadTemplate'
      const title = '批量开票模板下载'
      this.global.exportExcel(url, { templateName: 'InvoiceLimitExcel' }, title).catch(res => {
        let blob = new Blob([res.response.data], {
          type: 'application/json'
        })
        var blobReader = new Response(blob).json()
        blobReader.then(res => {
          this.$message.error(res.message)
        })
      })
    },
    // 查看明细
    handleViewDetail(row) {
      this.$router.push({
        path: '/invoiceManagement/limitMonitoring/detail',
        query: {
          invoiceId: row.invoiceId
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.row-bg {
  padding: 10px 0;
  display: flex;
  align-items: center;
}
.btn-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/invoiceManagement/limitMonitoring/index.vue